<template>
  <ul class="flex">
    <li v-for="item in options" :key="item.value" class="mb-0 mr-1">
      <a
        :class="item.value === value ? activeClass : inactiveClass"
        href="#"
        @click="() => updateValue(item.value)"
        :value="item.value"
        >{{ item.text }}</a
      >
    </li>
  </ul>
</template>

<script>
export default {
  name: "MoskitoTabs",
  props: {
    options: { type: Array, required: true },
    value: { type: [String, Number], required: true },
  },
  data() {
    return {
      activeClass:
        "bg-white inline-block py-2 px-4 text-blue-700 font-semibold border-l border-t border-r rounded-t",
      inactiveClass:
        "bg-white inline-block py-2 px-4 text-blue-500 hover:text-blue-800",
    };
  },
  methods: {
    updateValue(value) {
      this.$emit("input", value);
    },
  },
};
</script>

<style></style>
